import React from 'react';
import { Icon, Spin } from '../components/ui.jsx';

export const LoginPage = ({onLogin}) => {
  const [mode, setMode] = React.useState('login'); // login | forgot | reset
  const [password, setPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [resetToken, setResetToken] = React.useState('');

  // Check URL for reset token on mount
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('reset');
    if (token) {
      setResetToken(token);
      setMode('reset');
      // Clean URL
      window.history.replaceState({}, '', '/');
    }
  }, []);

  const submitLogin = async () => {
    if (!password.trim()) return;
    setLoading(true); setError(''); setSuccess('');
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({username: 'admin', password})
      });
      const data = await r.json();
      if (r.ok && data.token) {
        localStorage.setItem('ejatv_token', data.token);
        localStorage.setItem('ejatv_user', data.username);
        onLogin(data);
      } else {
        setError(data.detail || 'Login fallito');
      }
    } catch(e) {
      setError('Errore di connessione');
    }
    setLoading(false);
  };

  const submitForgot = async () => {
    setLoading(true); setError(''); setSuccess('');
    try {
      const r = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({})
      });
      const data = await r.json();
      if (r.ok) {
        setSuccess(data.message || 'Richiesta inviata');
      } else {
        setError(data.detail || 'Errore');
      }
    } catch(e) {
      setError('Errore di connessione');
    }
    setLoading(false);
  };

  const submitReset = async () => {
    if (!newPassword.trim()) return;
    if (newPassword !== confirmPassword) { setError('Le password non coincidono'); return; }
    if (newPassword.length < 4) { setError('Password troppo corta (min 4 caratteri)'); return; }
    setLoading(true); setError(''); setSuccess('');
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({token: resetToken, password: newPassword})
      });
      const data = await r.json();
      if (r.ok) {
        setSuccess('Password reimpostata! Puoi accedere.');
        setTimeout(() => { setMode('login'); setSuccess(''); }, 2000);
      } else {
        setError(data.detail || 'Token non valido o scaduto');
      }
    } catch(e) {
      setError('Errore di connessione');
    }
    setLoading(false);
  };

  const titles = {
    login: {title: 'EjaTV', sub: 'Broadcast Manager', icon: 'clapperboard'},
    forgot: {title: 'Recupera password', sub: 'Invieremo un link di reset', icon: 'mail'},
    reset: {title: 'Nuova password', sub: 'Imposta la tua nuova password', icon: 'lock'},
  };
  const t = titles[mode];

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',
      background:'linear-gradient(135deg, #31367A 0%, #1a1e4a 100%)'}}>
      <div style={{width:380,background:'#fff',borderRadius:16,padding:'40px 36px',
        boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:28}}>
          <div style={{width:56,height:56,borderRadius:14,background:'#31367A',
            display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px'}}>
            <Icon name={t.icon} size={28} color="#fff"/>
          </div>
          <div style={{fontSize:20,fontWeight:700,color:'#1a1e4a'}}>{t.title}</div>
          <div style={{fontSize:13,color:'#94a3b8',marginTop:2}}>{t.sub}</div>
        </div>

        {error && (
          <div style={{padding:'10px 14px',background:'#FEE2E2',border:'1px solid #FCA5A5',
            borderRadius:8,fontSize:12,color:'#991B1B',marginBottom:16,
            display:'flex',alignItems:'center',gap:6}}>
            <Icon name="alert-circle" size={14} color="#991B1B"/>{error}
          </div>
        )}

        {success && (
          <div style={{padding:'10px 14px',background:'#E6F9EF',border:'1px solid #A3E4C1',
            borderRadius:8,fontSize:12,color:'#065F46',marginBottom:16,
            display:'flex',alignItems:'center',gap:6}}>
            <Icon name="check-circle" size={14} color="#065F46"/>{success}
          </div>
        )}

        {/* ── LOGIN ── */}
        {mode === 'login' && <>
          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,fontWeight:600,color:'#64748b',display:'block',marginBottom:6}}>
              Password
            </label>
            <input type="password" className="input" value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submitLogin()}
              placeholder="Inserisci la password"
              autoFocus
              style={{width:'100%',padding:'12px 14px',fontSize:14}}/>
          </div>
          <button className="btn btn-primary" onClick={submitLogin} disabled={loading}
            style={{width:'100%',padding:'12px',fontSize:14,fontWeight:600}}>
            {loading ? <Spin/> : 'Accedi'}
          </button>
          <div style={{textAlign:'center',marginTop:14}}>
            <button onClick={() => {setMode('forgot');setError('');setSuccess('');}}
              style={{background:'none',border:'none',color:'#31367A',fontSize:12,
                fontWeight:600,cursor:'pointer',padding:4}}>
              Password dimenticata?
            </button>
          </div>
        </>}

        {/* ── FORGOT ── */}
        {mode === 'forgot' && <>
          <p style={{fontSize:13,color:'#64748b',marginBottom:20,lineHeight:1.6,textAlign:'center'}}>
            Verrà inviato un link di reset all'email dell'amministratore configurata nelle impostazioni.
          </p>
          <button className="btn btn-primary" onClick={submitForgot} disabled={loading}
            style={{width:'100%',padding:'12px',fontSize:14,fontWeight:600}}>
            {loading ? <Spin/> : 'Invia link di reset'}
          </button>
          <div style={{textAlign:'center',marginTop:14}}>
            <button onClick={() => {setMode('login');setError('');setSuccess('');}}
              style={{background:'none',border:'none',color:'#31367A',fontSize:12,
                fontWeight:600,cursor:'pointer',padding:4,display:'flex',alignItems:'center',
                gap:4,margin:'0 auto'}}>
              <Icon name="arrow-left" size={12} color="#31367A"/>Torna al login
            </button>
          </div>
        </>}

        {/* ── RESET ── */}
        {mode === 'reset' && <>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:600,color:'#64748b',display:'block',marginBottom:6}}>
              Nuova password
            </label>
            <input type="password" className="input" value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Minimo 4 caratteri"
              autoFocus
              style={{width:'100%',padding:'12px 14px',fontSize:14}}/>
          </div>
          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,fontWeight:600,color:'#64748b',display:'block',marginBottom:6}}>
              Conferma password
            </label>
            <input type="password" className="input" value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submitReset()}
              placeholder="Ripeti la password"
              style={{width:'100%',padding:'12px 14px',fontSize:14}}/>
          </div>
          <button className="btn btn-primary" onClick={submitReset} disabled={loading}
            style={{width:'100%',padding:'12px',fontSize:14,fontWeight:600}}>
            {loading ? <Spin/> : 'Reimposta password'}
          </button>
          <div style={{textAlign:'center',marginTop:14}}>
            <button onClick={() => {setMode('login');setError('');setSuccess('');}}
              style={{background:'none',border:'none',color:'#31367A',fontSize:12,
                fontWeight:600,cursor:'pointer',padding:4,display:'flex',alignItems:'center',
                gap:4,margin:'0 auto'}}>
              <Icon name="arrow-left" size={12} color="#31367A"/>Torna al login
            </button>
          </div>
        </>}

        <div style={{textAlign:'center',marginTop:20,fontSize:11,color:'#cbd5e1'}}>
          Terra de Punt · Broadcast Manager
        </div>
      </div>
    </div>
  );
};
